import React, { useEffect, useState } from 'react';
import {
  Alert, Box, CircularProgress, Typography,
} from '@mui/material';
import { fetchGabbaiUpcomingExams } from '../gabbaiPortalApi';
import { getGabbaiTheme } from '../gabbaiPortalTheme';
import { formatHebrewDate } from '../../../utils/hebrewDate';

function formatDate(d) {
  return formatHebrewDate(d, { weekday: true }) || null;
}

export default function ExamDatesScreen() {
  const t = getGabbaiTheme();
  const [periods, setPeriods] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      setError('');
      try {
        const data = await fetchGabbaiUpcomingExams();
        if (!cancelled) {
          setPeriods(data.data || []);
        }
      } catch (err) {
        if (!cancelled) setError(err.response?.data?.error || 'שגיאה בטעינת המועדים');
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  if (loading) {
    return (
      <Box sx={{ display: 'grid', placeItems: 'center', py: 6 }}>
        <CircularProgress sx={{ color: t.accent }} />
      </Box>
    );
  }

  return (
    <Box sx={{ maxWidth: 640, mx: 'auto' }}>
      <Typography sx={{ color: 'rgba(245,240,230,0.7)', mb: 2, textAlign: 'center' }}>
        מועדי המבחנים במערכת
      </Typography>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      {!error && !periods.length && (
        <Alert severity="info" sx={{ borderRadius: 2 }}>
          אין מועדים להצגה כרגע
        </Alert>
      )}
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
        {periods.map((period, idx) => {
          const dateLabel = formatDate(period.date);
          const isNext = idx === 0 || period.isActive;
          return (
            <Box
              key={period.id}
              sx={{
                border: `1px solid ${isNext ? t.accentSoft : t.cardBorder}`,
                background: isNext ? t.surfaceSelected : t.cardBg,
                borderRadius: 2.5,
                px: 2.25,
                py: 2,
              }}
            >
              {period.isActive && (
                <Typography sx={{ color: t.accent, fontSize: '0.75rem', fontWeight: 700, mb: 0.5 }}>
                  המועד הפעיל
                </Typography>
              )}
              {!period.isActive && idx === 0 && (
                <Typography sx={{ color: t.accent, fontSize: '0.75rem', fontWeight: 700, mb: 0.5 }}>
                  המועד הקרוב
                </Typography>
              )}
              <Typography sx={{ color: '#f5f0e6', fontWeight: 700, fontSize: '1.15rem' }}>
                {period.name}
              </Typography>
              {dateLabel && (
                <Typography sx={{ color: 'rgba(245,240,230,0.75)', mt: 0.5 }}>
                  {dateLabel}
                </Typography>
              )}
              {!dateLabel && (
                <Typography sx={{ color: 'rgba(245,240,230,0.5)', mt: 0.5, fontSize: '0.9rem' }}>
                  תאריך טרם נקבע
                </Typography>
              )}
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}
